const baseFileUrl = 'cd/ths-frontend-common-lib-container/v1.3.3';

export enum thsModulesKey {
  bridge = 'bridge',
  stat = 'stat',
  backWash = 'backWash',
}

export const thsModules = {
  [thsModulesKey.bridge]: {
    fileUrl: `${baseFileUrl}/common`,
    fileName: 'bridge.js',
    fnName: ['callNativeHandler'],
  },
  [thsModulesKey.stat]: {
    fileUrl: `${baseFileUrl}/business`,
    fileName: 'stat.js',
    fnName: ['getPlatform', 'getAppVersion'],
  },
  [thsModulesKey.backWash]: {
    fileUrl: `js/m/v2.12/common/;zepto.js;/js/m/business/backWash`,
    fileName: 'backWash_v3.7.js',
    fnName: ['backWash'],
  },
};

export enum thsToNative {
  getGMGInfo = 'getGMGInfo', // 获取信息
  share = 'hexinShare', // 唤起同花顺页面的分享
  downloadFile = 'HXDownloadFile', // 打开PDF
  redirectTrade = 'redirectTrade', // 跳转到交易页面
  redirectOldPage = 'jumpWTPage', //
}
